import { SceneDescriptor } from '../types'

/**
 * RJF_01「プログラミングのチカラでボスをたおせ！」のシーン記述。
 *
 * MVP 初期ターゲット。Chapter 1-3 で使うブロック
 * （onPlay / moveSteps / seeThrough、unsetCanCollide は no-op）で完結する。
 * オブジェクト名はミッション定義 `src/missions/RJF_01.ts` の objects[].name と一致させ、
 * Blockly workspace との紐付けキーにする。
 *
 * 座標は Studio テンプレートの厳密値ではなく、学習体験上わかりやすい近似配置。
 */
export const rjf01Scene: SceneDescriptor = {
  missionId: 'RJF_01',
  title: 'プログラミングのチカラでボスをたおせ！',
  objects: [
    {
      id: 'greenFloor',
      name: '②みどりのゆか',
      shape: 'box',
      position: { x: 0, y: -0.5, z: 0 },
      size: { x: 30, y: 1, z: 16 },
      color: '#3fa34d',
      isStatic: true,
    },
    {
      id: 'pinkWall',
      name: '①ピンクのかべ',
      shape: 'box',
      position: { x: -10, y: 3, z: 0 },
      size: { x: 1, y: 6, z: 6 },
      color: '#ff69b4',
    },
    {
      id: 'switch',
      name: '③スイッチ',
      shape: 'box',
      position: { x: 0, y: 1, z: 6 },
      size: { x: 2, y: 2, z: 2 },
      color: '#f5c518',
    },
    {
      id: 'bossFloor',
      name: '④ボスのゆか',
      shape: 'box',
      position: { x: 12, y: 0.5, z: 0 },
      size: { x: 6, y: 1, z: 6 },
      color: '#c0392b',
      isStatic: true,
    },
  ],
  avatar: {
    spawn: { x: -4, y: 1, z: 0 },
    size: { x: 1.2, y: 2, z: 1.2 },
    speed: 8,
    color: '#2e86de',
  },
  camera: {
    // 自由視点の初期位置はやや遠目で全景が見えるようにする。
    position: { x: 30, y: 22, z: 36 },
    target: { x: 0, y: 2, z: 0 },
  },
}
